import { useAuth0 } from '@auth0/auth0-react';
import { Navigate } from 'react-router';
import AccordionPanel from './Components/AccordionPanel';
import VerifyEmailInstructions from './Components/VerifyEmailInstructions';
import SignupFlowLayout from '@/Components/layouts/SignupFlowLayout/SignupFlowLayout';
import { LoadingOverlay } from '@/Components/shared';
import { useUserSignupNavigationContext } from '@/Context/UserSignupNavigationContext';
import RoutePath from '@/Routing/RoutePath';

function VerifyEmail() {
    const { user } = useAuth0();
    const { isLoading } = useUserSignupNavigationContext();

    if (isLoading) {
        return <LoadingOverlay />;
    }

    if (user?.email_verified) {
        return <Navigate to={RoutePath.Provision} replace />;
    }

    return (
        <SignupFlowLayout currentStep="verify-email">
            <VerifyEmailInstructions email={user?.email as string} />
            <div className="border-border w-full border-t" role="separator" />
            <AccordionPanel />
        </SignupFlowLayout>
    );
}

export default VerifyEmail;
